<div class="table1">
  <div class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container
      *ngFor="let disCol of tableColumns; let colIndex = index"
      matColumnDef="{{ disCol.columnDef }}"
    >
      <th mat-header-cell *matHeaderCellDef class="header">
        <mat-checkbox
          *ngIf="disCol.isSelect"
          (change)="selectAll($event.checked)"
        ></mat-checkbox>
        {{ disCol.header.length > 3 ? (disCol.header | titlecase): (disCol.header | uppercase) }}
      </th>

      <td mat-cell *matCellDef="let element" class="{{element.class}}" [ngClass]="{'blinker': disCol.cell(element).length > 74}">
        <ng-container *ngIf="!disCol.isLink && !disCol.isSelect && !disCol.hasBtn; else link">
          <ng-container *ngIf="formatted; else normal">
            <span>
              <div *ngIf="disCol.cell(element).includes(':') && getExpansionText(disCol.cell(element)).items; else aaa">
                <div *ngFor="let lineItem of (getExpansionText(disCol.cell(element))).items">
                  <strong>{{ lineItem[0]}}</strong>: {{lineItem[1] | slice: 0:30}}{{lineItem[1].length > 30 ? '...' : ''}}
                </div>
              </div>
              <ng-template #aaa>
                <div>{{disCol.cell(element).includes(":") ? (disCol.cell(element) | slice: 0:60) : disCol.cell(element)}}</div>
              </ng-template>
              <svg *ngIf="getExpansionText(disCol.cell(element)).showmore" (click)="expanItem.classList.add('d-block'); bd.classList.add('d-block')" class="show-more" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
                <path d="M12,0C5.38,0,0,5.38,0,12c0,6.62,5.38,12,12,12c6.62,0,12-5.38,12-12C24,5.38,18.62,0,12,0z M12,22C6.49,22,2,17.51,2,12
                  C2,6.49,6.49,2,12,2c5.51,0,10,4.49,10,10C22,17.51,17.51,22,12,22z M20,11v2h-7v7h-2v-7H4v-2h7V4h2v7H20z"/>
              </svg>
            </span>
            <div #expanItem class="expandable-item">
              <div class="_title">{{disCol.header | uppercase}}</div>
              <div class="_item" *ngFor="let lineItem of getExpansionText(disCol.cell(element)).items"><strong>{{lineItem[0]}}</strong>: {{lineItem[1]}}</div>
            </div>
            <div #bd class="expand-backdrop" (click)="closeItem(expanItem); closeItem(bd)"></div>
          </ng-container>
          <ng-template #normal>
            <span>
              {{ disCol.cell(element) | titlecase | slice:0:74  }}
            </span>
          </ng-template>
        </ng-container>

        <ng-template #link>
          <a
            *ngIf="!disCol.isSelect && !disCol.hasBtn; else selection"
            [href]="[disCol.url(element)]"
            target="_blank"
          >
            {{ disCol.cell(element) }}
          </a>
        </ng-template>
        <mat-checkbox
          #checkboxes
          customId="{{ disCol.cell(element) }}"
          *ngIf="disCol.isSelect"
          (change)="onSelect($event.checked, element._id)"
        ></mat-checkbox>

        <ng-container *ngIf="disCol.hasBtn">
          <button class="btn" *ngFor="let btn of disCol.buttonArray" (click)="btn.btnFn(element._id)">{{btn.name}}</button>
        </ng-container>

      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<mat-paginator [length]="totalCount" [pageSize]="pageSize"></mat-paginator>
